const actions = {
  FETCH_SITES: 'FETCH_SITES',
  FETCH_SITES_SUCCESS: 'FETCH_SITES_SUCCESS',
  FETCH_SITES_ERROR: 'FETCH_SITES_ERROR',
  SITE_SET: 'site/SET_VALUE',
  SITE_ADD: 'site/ADD_VALUE',
  SITE_DEL: 'site/DEL_VALUE',
  SITE_SUCCESS: 'site/SUCCESS',
  SITE_ERROR: 'site/ERROR',
}

export default actions
